import { Fragment, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import AsyncFilter from "src/components/common/frame/asyncFilter";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    myAxios, 
    scroll, 
    boolAndReducer, 
    getTimeStamp, 
    isDevMode, 
    appTitle, 
} from "src/components/common/functions";
import Detail from "./detail";
import Export from "./export";
import OrganizationForm from "./organizationForm";
//--------------------------------------------------------------------------------------------
export default function Organizations({ tabTitle }){
    const width = "40rem";
    const url = "organizations/readOrgs.php";
    const dataFrame = [
        {label: "Organization Name", key: "organizationName"}, 
        {label: "Website", key: "website"}, 
        {label: "Phone Nubmer", key: "phoneNumber"}, 
        {label: "Fax", key: "fax"}, 
        {label: "Street", key: "street"}, 
        {label: "City", key: "city"}, 
        {label: "State", key: "state"}, 
        {label: "Postal Code", key: "postalCode"}, 
        {label: "Country", key: "country"}, 
        {label: "Background", key: "background"}, 
    ]
    const defaultFilter = Object.fromEntries(dataFrame.map(item => [item.key, ""]));
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const organizations = useMyStore(state => state.organizations);
    const setOrganizations = useMyStore(state => state.setOrganizations);
    const organizationDetails = useMyStore(state => state.organizationDetails);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? ""); // title
    const path2 = decodeURIComponent(path.split("/")[2] ?? ""); // hash | "Add"
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Organizations": organizations.updatedAt === null?getTimeStamp():organizations.updatedAt, 
        "OrganizationDetails": organizationDetails.updatedAt === null?getTimeStamp():organizationDetails.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [curFilter, setFilter] = useState(defaultFilter);
    const [activeFilter, setActiveFilter] = useState(defaultFilter);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredOrganizations = organizations.data.filter(u => 
        (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    const currentUserList = filteredOrganizations.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredOrganizations.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const prevDependencies = useRef({ path1, path2 });
    useEffect(() => {
        if(updateDateTime["Organizations"] === organizations.updatedAt) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            if(isDevMode) console.log("useEffect");
            //-------------------------
            setShowLoading(true);
            const res = await myAxios("organizations/readOrgs.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-------------------------
            setOrganizations(res.data, updateDateTime["Organizations"]);
            if(!res.data.find(u => path2 === u.organizationHashKey)){
                switch(path2){
                    case "Add":
                        return; 
                    case undefined:
                        return
                    default:
                }
                history.replace(`/${path1}`);
                return;
            }
        }
        getData();
        prevDependencies.current = { path1, path2 };
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[history, updateDateTime, path1, path2, setOrganizations, organizations.updatedAt])
    useEffect(() => {
        if(path2 !== "" && path2 !== "Add"){
            const hashkeys = filteredOrganizations.map(v => v.organizationHashKey);
            setCurrentPage(Math.ceil((hashkeys.indexOf(path2) + 1) / itemsPerPage));
            scroll(path2);
        }
    }, [path2, itemsPerPage, filteredOrganizations, history])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <button
                        type = "button"
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary ml-3"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >↻</button>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <AsyncFilter
                    setCurrentPage = {setCurrentPage}
                    setFilter = {setFilter}
                    setActiveFilter = {setActiveFilter}
                    curFilter = {curFilter}
                    activeFilter = {activeFilter}
                    defaultFilter = {defaultFilter}
                    width = {width}
                    url = {url}
                    dataFrame = {dataFrame}
                    setItems = {useMyStore(state => state.setOrganizations)}
                />
                <Export
                    filteredOrganizations = {filteredOrganizations}
                />
                <button type = "button" className = "headerButton" onClick = {() => {history.push(`/${path1}/Add`);}}>Add</button>
                {path2 === "Add"?
                <OrganizationForm
                    closeIt = {() => history.push(`/${path1}`)}
                    history = {history}
                    keyword = "Add"
                />
                :null}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !currentUserList.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th></th>
                                <th>Organization Name</th>
                                <th>Website</th>
                                <th>Phone Number</th>
                                <th>Fax</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUserList.map((org, key) => 
                            <Fragment key = {key}>
                                <tr>
                                    <td>
                                        <button
                                            type = "button"
                                            className = {(path2 === org.organizationHashKey?"showMinus":"showPlus") + " childRow"}
                                            id = {org.organizationHashKey}
                                            onClick = {e => {
                                                if(path2 !== e.currentTarget.id){
                                                    history.push(`/${path1}/${e.currentTarget.id}`);
                                                    scroll(e.currentTarget.id);
                                                }else{
                                                    history.push(`/${path1}`);
                                                    scroll(null);
                                                }
                                            }}
                                        />
                                    </td>
                                    
                                    <td>{org.organizationName}</td>
                                    <td>{org.website?<a href = {org.website} target = "_blank" rel = "noreferrer">{org.website}</a>:<></>}</td>
                                    <td>{org.phoneNumber?<a href = {`tel:+1${org.phoneNumber.replace(/-/g, "")}${org.extension?`,${org.extension}`:""}`}>{org.phoneNumber}{org.extension?` Ext. ${org.extension}`:null}</a>:<></>}</td>
                                    <td>{org.fax?<a href = {"fax:+1" + org.fax.replace(/-/g, "")}>{org.fax}</a>:<></>}</td>
                                </tr>
                                <tr>
                                    <td className = "noborder" colSpan = {100}>
                                        <TransitionWidthHeight 
                                            classNames = "cssTDTransition"
                                            In = {path2 ===  org.organizationHashKey}
                                        >
                                            <Detail
                                                updateDateTime = {updateDateTime}
                                                org = {org}
                                                history = {history}
                                                setCurrentPage = {setCurrentPage}
                                            />
                                        </TransitionWidthHeight>
                                    </td>
                                </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredOrganizations.length?
                <Footer
                    length = {filteredOrganizations.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}

                    paginateAction = {() => history.push(`/${path1}`)}
                />
                :null}
            </div>
        </div>
    )
}